import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function CMSRootTreeItem() {
  const { Link } = useRouter()
  return (
    <div className="flex w-full items-center justify-between py-2">
      <div className="flex items-center gap-2">
        <SvgIcon name="database-01" />
        <T id="Generics.CMS" defaultMessage="CMS" />
      </div>
      <IconButton
        as={Link}
        className="w-auto h-auto p-1 mx-2"
        variant="tertiaryNeutral"
        href={adminRoutes.site.cms.new}
        icon={<SvgIcon name="plus" size="sm" />}
      />
    </div>
  )
}
